
<template>
<value_container
  md="4"
  label="Tiempo Estimado para Falla"
  :value="disabled? selectedItem[title_keys[1]]: selectedItem[title_keys[1]] || 'ingresar'"
  :click="()=>dialog=true"
  :class_name="disabled?'':(!selectedItem[title_keys[1]] && 'divEmpty')"
  :class_container="disabled?'':'ie-input'">
  <v-dialog v-model="dialog" persistent max-width="480">
    <v-card flat class="fullHeight pa-40 textAlignCenter">
      <h2>Estimación periodo de tiempo de falla</h2>
      <br>
      <table class="posibilityTable" style=" width: 400px;">
        <thead>
          <tr>
            <!-- <th v-for="(v,i) in title_keys" :key="i">{{titles[v]}}</th> -->
            <th>{{titles[title_keys[1]]}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in values"
            :key="i"
            @click="set(v[title_keys[2]])"
            :class="getClass(v[title_keys[2]])">
            <td>
              <fs1-span>{{v[title_keys[1]]}}</fs1-span>
            </td>
          </tr>
        </tbody>
      </table>
      <br>
      <div>
        <v-btn color="secondary" @click="dialog = false">
          <v-icon></v-icon>
          <span>Cerrar</span>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</value_container>
<!-- <div>
  <v-layout wrap>
    <v-flex>
      <v-btn color="primary" @click="dialog=true" style="width: 100%; font-weight: bolder;">
        Frecuencia de fallla
      </v-btn>
    </v-flex>
  </v-layout>
  <p style="text-align: center; font-weight: bolder;">
    <fs1-span>{{selectedItem[title_keys[1]]}}</fs1-span>
  </p> -->
  <!-- <v-layout wrap style="text-align: center; font-weight: bolder;">
    <v-flex md6 class="pa-4">
      <fs1-div>Incertidumbre</fs1-div>
      <fs1-div style="color:orangered">{{selectedItem.nivel||0}}</fs1-div>
    </v-flex>
    <v-flex md6 class="pa-4">
      <fs1-div>Factor de probabilidad</fs1-div>
      <fs1-div style="color:orangered">{{selectedItem.factor||0}}</fs1-div>
    </v-flex>
  </v-layout> -->



<!-- </div> -->
</template>

<script>
import { likelihood_values as values, likelihood_titles as titles } from '@/objects/general.js';
import value_container from '@/components/outputs/value_container.vue';
export default {
  props: ['value','disabled'],
  components:{value_container},
  data() {
    return {
      dialog:false,
      values,
      titles,
    };
  },
  computed:{
    title_keys(){ return Object.keys(this.values[0]) },
    selectedItem(){ return this.values.find(s=>s.factor===this.value)||{}}
  },
  methods: {
    set(v){ 
      if(!this.disabled) this.$emit('update:value', v);
      this.dialog = false;
    },
		getClass(v){
			if (this.value === v) return 'selected';
			if (this.disabled) return 'disabled';
			return '';
    },
  }, // methods
};
</script>
<style scoped>
.posibilityTable tbody>tr.selected>td{
  background: khaki !important;
}
</style>